import React from 'react';
import PropTypes from 'prop-types';
import ReactSortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';

const propTypes = {
  nodeComponentClass: PropTypes.func,
  nodeContentComponentClass: PropTypes.func,
};

const defaultProps = {
  nodeComponentClass: undefined,
  nodeContentComponentClass: undefined,
};

const SortableTree = ({
  nodeComponentClass: Node,
  nodeContentComponentClass: NodeContent,
  ...rest
}) => (
  <ReactSortableTree
    {...rest}
    isVirtualized={false} // https://github.com/frontend-collective/react-sortable-tree/issues/264
    theme={{
      nodeContentRenderer: NodeContent,
      treeNodeRenderer: Node,
    }}
  />
);

SortableTree.propTypes = propTypes;
SortableTree.defaultProps = defaultProps;

export default SortableTree;
